


<h2 mat-dialog-title class="auditTrain-heading"><a style="color: white; font-size: 22px;font-family: sans-serif;"><b>Audit Trail</b></a> </h2>
<div style="height:400px; overflow-y: scroll;" >
<table class="dataTable table table-striped1">
        <thead>
          <tr>

              <th>Field Name</th>
              <th>Old Value</th>
              <th>New Value</th>
              <th>Action</th>
              <th>Created On</th>
              <th>User</th>
          </tr>
        </thead>
        <tbody>
            <tr *ngIf="AuditrailData.length==0">
                <td colspan="7" style="text-align: center;color: red;">
                    No record found.
                </td>
            </tr>
            <tr *ngFor="let item of AuditrailData;let i = index">
                <td>{{item.FieldName}}</td>
                <td>{{item.OldValue}}</td>
                <td>{{item.NewValue}}</td>
                <td>{{item.Action }}</td>
                <td>{{item.CreatedOn | date:'dd-MMM-yyy HH:mm:ss'}}</td>
                <td>{{item.EmpName}}</td>
            </tr>

        </tbody>
    </table>
</div>
    <div class="modal-footer">
            <button type="button" class="btn btn-primary auditTrain-btn" (click)="closeDialog()">Close</button>
    </div>




